import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/appearance'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'APPEARANCE_SETTINGS.TITLE',
        icon: 'color',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'appearance_settings_index',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
